import { View, Text } from "react-native";
import React from "react";
import NetInfo from "@react-native-community/netinfo";
import { Toast } from "react-native-toast-message/lib/src/Toast";
import translate from "../../functions/translate";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { addToken, refresh } from "../../redux/main/mainAction";

export default function Connection() {
  const [status, setStatus] = useState(true);
  const dispatch = useDispatch();
  NetInfo.addEventListener((state) => {
    if (!state.isConnected) {
      setStatus(false);
      Toast.show({
        type: "error",
        text1: translate("connection error"),
      });
    }
    if (state.isConnected && !status) {
      setStatus(true);
      dispatch(addToken(null, state.token));
      dispatch(refresh());
    }
  });
  return <View></View>;
}
